import { useContext, useEffect, useMemo, useState } from 'react';
import type { RefinedTrace, Span } from '@repo/shared';

import { useTracing } from '@/api/generated';
import { TraceContext } from '@/routes/(app)/(tracing)/context/trace-context';
import { refineTraces } from '@/routes/(app)/(tracing)/lib/utils';

export const useRefinedTraces = (componentName: string, isWorkflow = false) => {
  const [traces, setTraces] = useState<Array<RefinedTrace>>([]);
  const { data, isLoading } = useTracing(componentName);
  const { setTraces: setTraceContextTraces } = useContext(TraceContext);
  const refinedTraces = useMemo(
    () =>
      refineTraces((data?.traces ?? []) as unknown as Array<Span>, isWorkflow),
    [data?.traces, isWorkflow]
  );
  useEffect(() => {
    if (refinedTraces.length > 0) {
      setTraces(() => refinedTraces);
      setTraceContextTraces(() => refinedTraces);
    }
  }, [setTraceContextTraces, refinedTraces]);

  return { traces, isLoading };
};
